var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect, _rect2, _rect3, _rect4, _rect5, _path27, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path28, _rect16, _rect17, _rect18, _rect19, _rect20, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _rect21, _path37, _rect22, _path38, _path39, _path40, _rect23, _rect24, _rect25, _circle, _path41, _polygon2, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _circle2, _path63, _path64, _path65;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeneric1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 588.82 332.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e7f3fd;}.cls-2{fill:#77a0d5;}.cls-3{fill:#f19a5a;}.cls-4{fill:#e38540;}.cls-5{fill:#a5daee;}.cls-6{fill:#97d0e0;}.cls-7{fill:#fff;}.cls-8{fill:#6791c9;}.cls-9{fill:#98bce4;}.cls-10,.cls-11{fill:#2f5c9b;}.cls-11{opacity:0.5;}.cls-12{fill:#a3c5e9;}.cls-13{fill:#f39993;}.cls-14{fill:#9ecd98;}.cls-15{fill:#74b570;}.cls-16{fill:#18a0dc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IMG-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.37,474.46s-122.74-221-30.86-272.62c73.3-41.15,137.59,30.86,216-19.29,101.2-64.7,177.92-21.39,232.75,59.15,41.15,60.44,62.95,99.54,83.59,146.6,32.15,73.3-36,90-36,90Z",
    transform: "translate(-6.69 -151.23)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M424.49,475.9l-55.95.1a1.94,1.94,0,0,1-.17-3.74l55.73-5c4.52-.41,8.64,1.34,8.76,3.93S429,475.89,424.49,475.9Z",
    transform: "translate(-6.69 -151.23)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M352,468c1.93-.48,5.47-11,5.47-11S317.1,443.32,300,434.44l-23.87,27.61C306.76,469.69,350.61,468.34,352,468Z",
    transform: "translate(-6.69 -151.23)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M345.83,452.76c9.94,2.57,25.76-3.86,28.72-3.21s15.32,7.07,18.28,10.28,13.43,13.18,11.55,13.83-15.05-9-16.66-9.33-2.42,1.93-15.59,4.51S343,464.76,343,464.76Z",
    transform: "translate(-6.69 -151.23)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.65,462.73s15.32-3.86,17.2-3.22,13.3,3.22,21.23,12.22c-7.52-2.25-18.27-2.89-21.23-2.89S361.65,462.73,361.65,462.73Z",
    transform: "translate(-6.69 -151.23)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M365.31,456.3c6.54,8.36,23.15,10.93,25.66,13.82s-6.05,1.67-10.56,1.29c-11.5-1-19.54,3.69-28.85.8s-11.41-9.8-11.41-9.8Z",
    transform: "translate(-6.69 -151.23)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.71,307.92c-29.51,14.5-43,25.1-52.17,64.65s-9.65,77.15-4.83,105.12c32.76.95,126.63,4.48,126.63,4.48S310.55,424.75,301,379.32c-9.16-43.4-22.18-60.28-33.27-68S242.71,307.92,242.71,307.92Z",
    transform: "translate(-6.69 -151.23)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249.85,442.49c-10.58-10.61-7.72-82.46-25.08-114.77L192.46,388l-9.76,50.15a227.2,227.2,0,0,0,3,39.54,1.29,1.29,0,0,0,1.38,1.05c26.68-2.33,28.16-13.93,113.35-26.79C302.46,451.65,257,449.7,249.85,442.49Z",
    transform: "translate(-6.69 -151.23)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M239.9,307.93c-3.74,8.73,3.86,20.15,15.86,29.15s19.29,4.07,18.64-3-1.28-14.57-4.07-19.08-25.07-8.35-25.07-8.35S240.54,306.43,239.9,307.93Z",
    transform: "translate(-6.69 -151.23)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254.15,264.21l-11.44,43.71a10,10,0,0,0,.83,8.87c4.66,7.53,14.69,22,21.86,20.08,9.65-2.58,3.22-20.58,3.22-20.58L281.48,271Z",
    transform: "translate(-6.69 -151.23)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M271.68,266.91l-11.42-4.63-3.43,8.92c1.57,38,6.41,53.5,13.84,57.82.4-5.86-2.05-12.73-2.05-12.73l9.32-33.76Z",
    transform: "translate(-6.69 -151.23)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M303.42,284c-2.23,15.09-8.18,28-18.95,26.43s-29.28-14.22-27.06-29.31,26.42-33.16,37.2-31.57S305.65,268.94,303.42,284Z",
    transform: "translate(-6.69 -151.23)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M221.4,340.74c.86-3.43-12.87-5.47-15.05-2.7-21.6,27.46-55.18,101.65-47.64,115,8.68,15.43,102.19-4.83,104.12-5.31s-3.38-14.95-3.38-14.95-52.4,1-61.24-5C225.7,376.25,214.88,366.71,221.4,340.74Z",
    transform: "translate(-6.69 -151.23)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.09,325.31c-22.68,10.17-47.25,76.19-47.25,76.19s5.78,1.44,24.59,7.71c7.82,2.61,15.39,5,15.39,5s18-23.37,23.67-41.67C239.78,349,230.08,319,216.09,325.31Z",
    transform: "translate(-6.69 -151.23)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M171.27,395.3c21.21,2.74,33.89,10.12,40.33,15.17,1-1.35,2.14-3,3.43-4.91A52.58,52.58,0,0,0,186.75,392c-5.74-.8-10.1-1.32-13.41-1.65C172.55,392.16,171.86,393.84,171.27,395.3Z",
    transform: "translate(-6.69 -151.23)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M176.14,383.81c-.37.82-.72,1.62-1.06,2.41,18.63-.75,36.51,8.33,41,13.87l1.41,1.74,1.43-2.21c-3.06-3-8.49-7.85-14-10.25C193.71,384.47,177.58,383.85,176.14,383.81Z",
    transform: "translate(-6.69 -151.23)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "294.4 300.52 270.61 300.52 267.07 256.1 298.26 256.1 294.4 300.52"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256.56,433c6.59-.16,17.36-7.72,21.06-9.81s24.59-6.59,25.56-4.34-17.52,6.92-17.52,6.92l13.82.64s4,6.11,4.34,10.13-1.29,9.8-1.29,9.8l-6.1-5.46s-5,2.73-11.26,6.43-17.52,1.44-22.34.48-16.07-4.5-16.07-4.5Z",
    transform: "translate(-6.69 -151.23)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.4,430.9s10.67-6.16,21.38-4.66c6.14.86,6.81,1.86,6.43,1.61,1.33-2.5,2.57-4.89,3.72-7.19C196.35,420.92,182,422.43,170.4,430.9Z",
    transform: "translate(-6.69 -151.23)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M507,355.19V464.66c0,3.64-3.43,6.59-7.66,6.59h-23c-3.93,0-7.11,2.73-7.11,6.1H502.3c7.12,0,12.89-5,12.89-11.09V355.19Z",
    transform: "translate(-6.69 -151.23)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M490.16,448.94l-3.65-.7c-2.41-.45-3.94-2.53-3.41-4.6l28.61-111.11c.53-2.07,2.94-3.39,5.34-2.93l3.65.69c2.41.46,3.95,2.53,3.41,4.6L495.51,446C495,448.08,492.57,449.4,490.16,448.94Z",
    transform: "translate(-6.69 -151.23)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M491.16,449.13l-.43-.08a3,3,0,0,1-2.63-3.56l29-112.83a3.51,3.51,0,0,1,4.13-2.26l.43.08a3,3,0,0,1,2.63,3.55l-29,112.83A3.52,3.52,0,0,1,491.16,449.13Z",
    transform: "translate(-6.69 -151.23)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M567.3,483.7H76a4.12,4.12,0,0,1,0-8.24H567.3a4.12,4.12,0,0,1,0,8.24Z",
    transform: "translate(-6.69 -151.23)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.1,245.36c-22.26,13.81-8.17,28.74-14.09,54.38,3.64,1.25,7.61-5.91,10.15-11.55s4.79-13.81,5.64-13.53,2.25,13,2.25,13l3.38,1.69s4.79-8.46,4.51-10.43-4.23-11.55.56-16.06c3.08-2.9,15.78,3.38,15.78,3.38l-12.39-17.75Z",
    transform: "translate(-6.69 -151.23)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M259.1,245.36c-22.26,13.81-8.17,28.74-14.09,54.38,3.64,1.25,7.61-5.91,10.15-11.55s4.79-13.81,5.64-13.53,2.25,13,2.25,13l3.38,1.69s4.79-8.46,4.51-10.43-4.23-11.55.56-16.06c3.08-2.9,15.78,3.38,15.78,3.38l-12.39-17.75Z",
    transform: "translate(-6.69 -151.23)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M307.86,260.29c-1.13,13.53-22.1,9.3-31.85-2.81-9.3-11.56-16.95-3.59-26.2.28-15.5,6.48,2-31,33.25-25.08C306.53,237.12,308.61,251.29,307.86,260.29Z",
    transform: "translate(-6.69 -151.23)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.25,274.66c1,5-.92,9.64-4.21,10.27s-6.73-3-7.69-8,.92-9.65,4.21-10.27S260.29,269.61,261.25,274.66Z",
    transform: "translate(-6.69 -151.23)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 380.58,
    y: 85.83,
    width: 113.32,
    height: 67.51,
    rx: 2.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 384.06,
    y: 96.69,
    width: 106.37,
    height: 54.58,
    rx: 1.96
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 385.27,
    y: 89.65,
    width: 4.22,
    height: 3.8,
    rx: 0.92
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 392.95,
    y: 89.65,
    width: 4.22,
    height: 3.8,
    rx: 0.92
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 400.63,
    y: 89.65,
    width: 4.22,
    height: 3.8,
    rx: 0.92
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M493.51,299.28H394.35V251.13h99.16Zm-98.8-.35h98.45V251.49H394.71Z",
    transform: "translate(-6.69 -151.23)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 387.84,
    y: 138.14,
    width: 98.8,
    height: 0.36
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 387.84,
    y: 128.58,
    width: 98.8,
    height: 0.36
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 387.84,
    y: 119.02,
    width: 98.8,
    height: 0.36
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 387.84,
    y: 109.47,
    width: 98.8,
    height: 0.36
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 472.35,
    y: 100.08,
    width: 0.36,
    height: 47.79
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 458.24,
    y: 100.08,
    width: 0.36,
    height: 47.79
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 444.12,
    y: 100.08,
    width: 0.36,
    height: 47.79
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 430.01,
    y: 100.08,
    width: 0.36,
    height: 47.79
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 415.89,
    y: 100.08,
    width: 0.36,
    height: 47.79
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 401.78,
    y: 100.08,
    width: 0.36,
    height: 47.79
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M489.64,257.35h-3.32a2.31,2.31,0,1,1,0-4.61h3.32a2.31,2.31,0,0,1,0,4.61Z",
    transform: "translate(-6.69 -151.23)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 477.32,
    y: 120.8,
    width: 7.93,
    height: 4.61,
    rx: 1.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 403.38,
    y: 111,
    width: 10.93,
    height: 6.8,
    rx: 1.57
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 404.92,
    y: 111.95,
    width: 7.85,
    height: 4.89,
    rx: 1.13
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 459.96,
    y: 139.61,
    width: 10.93,
    height: 6.8,
    rx: 1.57
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 461.5,
    y: 140.57,
    width: 7.85,
    height: 4.89,
    rx: 1.13
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M448.65,264.21h-6.11a.75.75,0,0,1,0-1.5h6.11a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-6.69 -151.23)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M448.65,266.56h-6.11a.75.75,0,0,1,0-1.5h6.11a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-6.69 -151.23)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M435.15,292.66H429a.75.75,0,0,1,0-1.5h6.11a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-6.69 -151.23)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M435.15,295H429a.76.76,0,0,1,0-1.51h6.11a.76.76,0,0,1,0,1.51Z",
    transform: "translate(-6.69 -151.23)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M403.48,274.81h-6.11a.75.75,0,0,1-.75-.74.76.76,0,0,1,.75-.76h6.11a.76.76,0,0,1,.75.76A.75.75,0,0,1,403.48,274.81Z",
    transform: "translate(-6.69 -151.23)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M403.48,277.17h-6.11a.75.75,0,0,1,0-1.5h6.11a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-6.69 -151.23)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M462.47,264.21h-6.11a.75.75,0,0,1,0-1.5h6.11a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-6.69 -151.23)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M462.47,266.56h-6.11a.75.75,0,0,1,0-1.5h6.11a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-6.69 -151.23)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 403.22,
    y: 130.34,
    width: 11.89,
    height: 6.91,
    rx: 1.42
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M415.22,287.34h0a.77.77,0,0,1-.51-.24L413,285.17a.7.7,0,0,1,.07-1,.71.71,0,0,1,1,.06l1.2,1.37,3.08-3a.71.71,0,0,1,1,1l-3.61,3.54A.74.74,0,0,1,415.22,287.34Z",
    transform: "translate(-6.69 -151.23)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 445.5,
    y: 101.25,
    width: 11.89,
    height: 6.91,
    rx: 1.42
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M457.49,258.24h0A.67.67,0,0,1,457,258l-1.69-1.92a.71.71,0,1,1,1.06-.94l1.2,1.36,3.08-3a.71.71,0,1,1,1,1L458,258A.7.7,0,0,1,457.49,258.24Z",
    transform: "translate(-6.69 -151.23)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M461,284.78a3.22,3.22,0,1,1-3.22-3.21A3.22,3.22,0,0,1,461,284.78Z",
    transform: "translate(-6.69 -151.23)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M419.39,294.59a3.22,3.22,0,1,1-3.21-3.22A3.21,3.21,0,0,1,419.39,294.59Z",
    transform: "translate(-6.69 -151.23)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 364.61,
    y: 143.57,
    width: 67.85,
    height: 38.8,
    rx: 1.11
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 366.09,
    y: 145.28,
    width: 64.88,
    height: 35.38,
    rx: 1.04
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 367.89,
    y: 147.45,
    width: 61.29,
    height: 31.05,
    rx: 1.17
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 398.53,
    cy: 162.97,
    r: 10.77
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M414.5,314.2a9.28,9.28,0,1,1-9.28-9.28A9.27,9.27,0,0,1,414.5,314.2Z",
    transform: "translate(-6.69 -151.23)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "403.11 162.48 399.71 164.43 396.32 166.39 396.32 162.48 396.32 158.56 399.71 160.52 403.11 162.48"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M367,201.84H324.56a1.93,1.93,0,0,1,0-3.86H367a1.93,1.93,0,1,1,0,3.86Z",
    transform: "translate(-6.69 -151.23)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M477.9,364.83H435.47a1.93,1.93,0,0,1,0-3.86H477.9a1.93,1.93,0,1,1,0,3.86Z",
    transform: "translate(-6.69 -151.23)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M477.9,371.9H435.47a1.93,1.93,0,1,1,0-3.85H477.9a1.93,1.93,0,1,1,0,3.85Z",
    transform: "translate(-6.69 -151.23)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M477.9,379.62H435.47a1.93,1.93,0,1,1,0-3.86H477.9a1.93,1.93,0,1,1,0,3.86Z",
    transform: "translate(-6.69 -151.23)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M394.32,209.23H324.56a1.93,1.93,0,0,1,0-3.86h69.76a1.93,1.93,0,0,1,0,3.86Z",
    transform: "translate(-6.69 -151.23)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M93.13,316.14C82,326.27,86.86,336.4,95.06,355.2s9.64,88.24,9.64,88.24l-6.75-1s1-71.37-8.2-90.65-13-28.94-21.21-22.67S93.13,316.14,93.13,316.14Z",
    transform: "translate(-6.69 -151.23)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M99.22,303c-1.34-6-9.34-12.49-20-18,1.59,8.85,6.69,23.32,1.41,26.29-7.11,4-.69-16.2-3.44-27.31A132.46,132.46,0,0,0,43.9,273.1l.05.13c6.26,15.91,14.46,22.18,11.09,24.59-2.54,1.81-10.82-16.57-21.74-26-8.2-.44-15.13.67-19.23,3.92-6.35,5-10.6,9.48-4.22,24.77a28.58,28.58,0,0,0,13.84,5c14.47,1.45,21.22,1.93,11.09,6.76-5,2.36-13.27-.14-20-1.66,2.19,4,4.88,8.59,8.14,13.78A51.05,51.05,0,0,0,29.69,333c4.66.89,8.73.9,10.88,0,6.75-2.89,24.11-12.06,28.45-8.2S36.87,331,39.39,340.58c17.64,10.17,37.83,5.33,41.4-4C85.58,324,103.28,321.1,99.22,303Z",
    transform: "translate(-6.69 -151.23)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M62.75,371.6c19.29-14.47,39.06-1,49.19,14.46s2.89,50.15,2.89,50.15-3.86,0-3.86-1.44,10.61-41-14.46-58.83c-15.69-11.17-27-5.79-28.45-.49s6.26,14.95,6.26,14.95Z",
    transform: "translate(-6.69 -151.23)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M107.11,341.86c-19.28,0-25.55,29.9-20.25,47.26S99.4,438.78,99.4,438.78l4.82-4.82s-18.32-45.33-14-65.58,14.94-23.63,16.87-23.63S107.11,341.86,107.11,341.86Z",
    transform: "translate(-6.69 -151.23)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M90.94,389.25A14.08,14.08,0,0,0,85.86,385a39.15,39.15,0,0,0,1,4.14c2.42,7.91,5.23,18.92,7.59,28.56.21-1.23.54-3.13,1-6.07.12-.7.21-1.45.28-2.25A184.66,184.66,0,0,1,90.94,389.25Z",
    transform: "translate(-6.69 -151.23)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M85.66,389.4C49,374,68.32,352.79,36,366.77c-2.28,1-5.05,3.47-7.83,6.9a24.18,24.18,0,0,0,10.24.82c9.64-1.45,6.27,6.27-9.65,8.2a35.32,35.32,0,0,0-7.45,1.57c-7.59,14.56-11,33.72,5,40.38A36.4,36.4,0,0,0,37.79,427c5-3.93-1.21-26.7,6.42-23.56,7.33,3-2.29,19.52-1,23.68a106,106,0,0,0,22.89-3.21c3-1.7,5.34-4,6.05-7,2.41-10.12-13.5-16.39-14-25.07-.45-8,5.83,17.55,22.46,21.31C95.69,406.14,102.79,396.61,85.66,389.4Z",
    transform: "translate(-6.69 -151.23)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M111.78,362.11c-3.86-8.19,6.26-10.12,5.78-3.85-.43,5.55-.47,19.05,5.22,22.73a89.35,89.35,0,0,0,33.3-11.06,4.06,4.06,0,0,0-.42-2.51c-4.34-8.68-32.31-15.92-23.63-18.81,6.91-2.3,19,11.3,28.78,18.15,5.87-4.45,9.79-9.75,9.79-15.67,0-8-9.73-17.08-22.32-21.41-5.66.57-10.93,3.66-19.15,8.32-12.14,6.88-9.33-4.24,2.15-10.84A34.56,34.56,0,0,0,104.2,342s.69,4.32-3.89,11c-12.48,18.25,1.93,28.9,19.15,28.21C118.49,376.43,114.44,367.78,111.78,362.11Z",
    transform: "translate(-6.69 -151.23)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M63.91,370.78c-9.43,7.29-19.9,15.81-32.76,21.59S20.86,417,20.86,417s-1.93-16.29,8.79-21.86,17.79-12.22,25.93-13.5a117.6,117.6,0,0,0,12.64-2.58s-2.57-5.14-1.07-7.07S63.91,370.78,63.91,370.78Z",
    transform: "translate(-6.69 -151.23)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M17.43,285.21c34.51,9.22,59.8,31.29,64.51,36.65s4.72,6.86,4.72,6.86L83,335.58l-1.71-.86s2.78-5.79-4.5-13.29c-12.57-12.94-27.86-23.15-38.37-27.65S17.43,285.21,17.43,285.21Z",
    transform: "translate(-6.69 -151.23)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M75.83,277.72H123a0,0,0,0,1,0,0V308a17,17,0,0,1-17,17H92.81a17,17,0,0,1-17-17V277.72A0,0,0,0,1,75.83,277.72Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M343.37,350.66l.1.2h-.06A.23.23,0,0,1,343.37,350.66Z",
    transform: "translate(-6.69 -151.23)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M347.47,350.59c-.07-.07-.05-.15-.05-.23A.32.32,0,0,1,347.47,350.59Z",
    transform: "translate(-6.69 -151.23)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M347.52,351a.33.33,0,0,1,0-.22A.29.29,0,0,1,347.52,351Z",
    transform: "translate(-6.69 -151.23)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M347.59,351.47a.24.24,0,0,1,0-.22A.35.35,0,0,1,347.59,351.47Z",
    transform: "translate(-6.69 -151.23)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M343.47,350.93l.06.07Z",
    transform: "translate(-6.69 -151.23)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M344,351.75l.06.07Z",
    transform: "translate(-6.69 -151.23)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 398.46,
    cy: 162.9,
    r: 14.4
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M398,316.87c.09,0,.1-.05.12-.13.37-1.87.82-3.72,1.13-5.6a.41.41,0,0,1,.29-.36,3.15,3.15,0,0,1,2.26-.07,1.19,1.19,0,0,1,.79,1c.38,1.7.84,3.37,1.19,5.08,0,.05,0,.1.07.12s.06-.08.07-.14c.21-1.6.38-3.22.54-4.83.11-1.12.23-2.24.34-3.36a.35.35,0,0,1,.22-.34,2.35,2.35,0,0,1,2-.12,1.12,1.12,0,0,1,.74,1.21,22,22,0,0,1-.23,2.55,60.86,60.86,0,0,1-1,6c-.1.42-.22.83-.34,1.24a.83.83,0,0,1-.45.54,4.12,4.12,0,0,1-2.21.35,2.64,2.64,0,0,1-1.12-.33,1.08,1.08,0,0,1-.5-.67c-.35-1.25-.64-2.53-.94-3.8l-.08-.3c-.13.66-.25,1.26-.38,1.86-.18.81-.36,1.61-.53,2.41a.59.59,0,0,1-.28.41,2.86,2.86,0,0,1-1.37.43,3.82,3.82,0,0,1-1.86-.26,1.44,1.44,0,0,1-.85-1,33.1,33.1,0,0,1-.85-3.57,6.25,6.25,0,0,1-.19-1.05h0v.05l0,.05.32.57,0,.05a4.59,4.59,0,0,0,1.54,1.44A3.35,3.35,0,0,0,398,316.87Z",
    transform: "translate(-6.69 -151.23)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M412.78,320.16a5,5,0,0,1-2.77-.68,4.54,4.54,0,0,1-2.14-3.6,6.4,6.4,0,0,1,.25-2.95,4,4,0,0,1,3.33-2.83,4.19,4.19,0,0,1,3.22.71,4,4,0,0,1,1.63,3.51,1.23,1.23,0,0,1-.95,1.26c-.66.18-1.34.25-2,.37l-2.44.4c-.13,0-.15.07-.1.2a1.63,1.63,0,0,0,.64.75,3.11,3.11,0,0,0,2.13.32,4.22,4.22,0,0,0,1.58-.56c.11-.07.17,0,.26,0a1.57,1.57,0,0,1-.17,2.47,3.93,3.93,0,0,1-1.72.53A3.66,3.66,0,0,1,412.78,320.16Zm-2.13-6h0l2.68-.49c.13,0,.16-.08.1-.22l-.11-.27a1.36,1.36,0,0,0-1.66-.65,1.64,1.64,0,0,0-1.14,1.5C410.56,314.09,410.52,314.2,410.65,314.16Z",
    transform: "translate(-6.69 -151.23)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M397.18,310.6c-.06-.46-.12-.92-.19-1.38a1.31,1.31,0,0,0-.91-1.19,2.23,2.23,0,0,0-2.21.47.21.21,0,0,0-.1.21c.07.6.12,1.2.23,1.79l.54,3.35,0,.15.07.15v.05l0,.05.32.57,0,.05a4.59,4.59,0,0,0,1.54,1.44,3.35,3.35,0,0,0,1.45.56l-.3-2.26a.17.17,0,0,1,0-.17l0-.19s0-.1,0-.16v-.15c-.05,0,0-.1,0-.16v-.09Z",
    transform: "translate(-6.69 -151.23)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric1);
export default __webpack_public_path__ + "static/media/generic-1.b004e35ba225075a7d2cbb8008057922.svg";
export { ForwardRef as ReactComponent };